// Pfas error message based on geolocation
let message, suffixMessage, recycledmessage;
if (document.body.classList.contains("template-product")) {
  message = `Due to regional restrictions, this product with PFAS cannot be shipped to `;
  suffixMessage = ".";
} else {
  message = `One or more items in your cart are not available for shipment to `;
  suffixMessage = ". Please remove them before checking out.";
}
recycledmessage = `This product may not be deemed to be marketed as compostable in Washington or Colorado due to state regulations.`;
// for Pfas
const cartItem = document.querySelectorAll(".product-data");
const cartItemsDrawer = document.querySelectorAll(".product-data_cart");
// for Recycled Mark
const recycledMarkCartItem = document.querySelectorAll(
  ".recycled-product-data"
);
let errorMessage;
let recycledMarkMessage;
let stateCodeMetaField;
let recycledMetaField;
let pfasRestrictedDiv;
let stateCodeCustomerLoc;
function getLocation() {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    } else {
      reject(new Error("Geolocation is not supported by this browser."));
    }
  });
}
async function init() {
  try {
    const position = await getLocation();
    showPosition(position);
  } catch (error) {
    if (error.code === 1) {
      console.warn(
        "Geolocation is disabled. Please enable it to use this feature."
      );
    } else {
      console.error("Error getting geolocation");
    }
  }
}
function showPosition(position) {
  const latitude = position.coords.latitude;
  const longitude = position.coords.longitude;
  // PFAS
  cartItem.forEach((itemElement) => {
    stateCodeMetaField = itemElement.getAttribute("data-metafield");
    // Fetch state information and check the condition
    if (stateCodeMetaField) {
      reverseGeocode(latitude, longitude, itemElement, stateCodeMetaField);
    }
  });

  //Recycled Warning on Cart Page
  const recycledMetafield = document.querySelector(
    ".recycled-product-data[data-recycled-metafield]"
  );
  let recycledStateCodeMetaField;
  if (recycledMetafield) {
    recycledStateCodeMetaField = recycledMetafield.getAttribute(
      "data-recycled-metafield"
    );
    if (recycledStateCodeMetaField) {
      showRecycledWarning(
        latitude,
        longitude,
        recycledMetafield,
        recycledStateCodeMetaField
      );
    }
  }

//Recycled on Product Detail Page
  recycledMarkCartItem.forEach((itemElement) => {
    recycledMetaField = itemElement.getAttribute("data-metafield-recycled");
    if (recycledMetaField) {
      // Fetch state information and check the condition
      recycleReverseGeocode(
        latitude,
        longitude,
        itemElement,
        recycledMetaField
      );
    }
  });
}

// Pfas
function reverseGeocode(latitude, longitude, itemElement, stateCodeMetaField) {
  const geocodingApiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyDI3RRB1e1bVKrYfAXtNAo65u29BPGIRls`;
  fetch(geocodingApiUrl)
    .then((response) => response.json())
    .then((data) => {
      const addressComponents = data.results[0].address_components;
      // Find the state in the address components
      const state = addressComponents.find((component) =>
        component.types.includes("administrative_area_level_1")
      );
      stateCodeCustomerLoc = state.short_name; // getting state code from customer's location state
      errorMessage = message + `${state.long_name}` + suffixMessage;
      if (stateCodeMetaField.includes(stateCodeCustomerLoc)) {
        itemElement.innerHTML += `${errorMessage}`;
        // Dispatch a custom event with the message
        document.dispatchEvent(
          new CustomEvent("pfasWarning", { detail: { errorMessage } })
        );
      }
    })
    .catch((error) => {
      console.log("error", error);
    });
}
// Recycled Mark
function recycleReverseGeocode(
  latitude,
  longitude,
  itemElement,
  recycledMetaField
) {
  const geocodingApiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyDI3RRB1e1bVKrYfAXtNAo65u29BPGIRls`;
  fetch(geocodingApiUrl)
    .then((response) => response.json())
    .then((data) => {
      const addressComponents = data.results[0].address_components;
      // Find the state in the address components
      const state = addressComponents.find((component) =>
        component.types.includes("administrative_area_level_1")
      );
      stateCodeCustomerLoc = state.short_name; // getting state code from customer's location state
      recycledMarkMessage = recycledmessage;
      if (recycledMetaField.includes(stateCodeCustomerLoc)) {
        itemElement.innerHTML += `${recycledMarkMessage}`;
        // Dispatch a custom event with the message
        document.dispatchEvent(
          new CustomEvent("pfasWarning", { detail: { errorMessage } })
        );
      }
    })
    .catch((error) => {
      console.log("error", error);
    });
}
init();
// Pfas error message based on geolocation code end

function showRecycledWarning(
  latitude,
  longitude,
  recycledMetafield,
  recycledStateCodeMetaField
) {
  const geocodingApiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyDI3RRB1e1bVKrYfAXtNAo65u29BPGIRls`;
  fetch(geocodingApiUrl)
    .then((response) => response.json())
    .then((data) => {
      const addressComponents = data.results[0].address_components;
      // Find the state in the address components
      const state = addressComponents.find((component) =>
        component.types.includes("administrative_area_level_1")
      );
      stateCodeCustomerLoc = state.short_name; // getting state code from customer's location state

      // const recycledMetafield = document.querySelector('.recycled-product-data[data-recycled-metafield]');
      // let recycledStateCodeMetaField;
      // if (recycledMetafield) {
      //   recycledStateCodeMetaField = recycledMetafield.getAttribute('data-recycled-metafield');

      // }
      warningMessage =
        "One or more product may not be deemed to be marketed as compostable in Washington or Colorado due to state regulations.";
      if (recycledStateCodeMetaField.includes(stateCodeCustomerLoc)) {
        recycledMetafield.innerHTML += `${warningMessage}`;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    this.querySelectorAll(".quantity__button").forEach((button) =>
      button.classList.add("disabled")
    );

    if (
      document.querySelectorAll(
        '.card--product card__add-to-cart button[name="add"]'
      )
    ) {
      document
        .querySelectorAll(
          '.card--product .card__add-to-cart button[name="add"]'
        )
        .forEach((button) => {
          button.setAttribute("aria-disabled", false);
          button.querySelector("span").classList.remove("hidden");
          button.querySelector(".sold-out-message").classList.add("hidden");
        });
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        this.querySelectorAll(".quantity__button").forEach((button) =>
          button.classList.remove("disabled")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.querySelectorAll(".quantity__button").forEach((button) =>
          button.classList.remove("disabled")
        );
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );

    // pfas cart drawer code on load---------------------------------------
    cartItemsDrawer.forEach((itemElement) => {
      const line = itemElement.getAttribute("data-line");
      pfasRestrictedDiv = document.getElementById(
        `pfas_restricted_cart-${line}`
      );
      const stateCodeMetaField = itemElement.getAttribute("data-metafield");
      if (stateCodeMetaField.includes(stateCodeCustomerLoc)) {
        if (pfasRestrictedDiv.innerHTML != errorMessage) {
          pfasRestrictedDiv.innerHTML += `${errorMessage}`;
        }
      }
    });
    // pfas cart and product page code on load-----------------------------
    cartItem.forEach((itemElement) => {
      const line = itemElement.getAttribute("data-line");
      pfasRestrictedDiv = document.getElementById(`pfas_restricted-${line}`);
      const stateCodeMetaField = itemElement.getAttribute("data-metafield");
      if (stateCodeMetaField.includes(stateCodeCustomerLoc)) {
        pfasRestrictedDiv.innerHTML = `${errorMessage}`;
      }
    });
    // --------------------------------------------------
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
